import { observable, action } from "mobx";
import { Usuario } from "../../../services";
import { sessaoStore } from "../../../stores";
import { error, success } from "../../../utils/MensagemUtil";
import { validarCamposObrigatorios } from "../../../utils/Validate";
import * as CsAvatar from "../../../constantes/CsAvatars";

class PerfilStore {
  @observable
  usuario = {
    nome: "",
    email: "",
    login: "",
    avatar: "",
    senhaAtual: "",
    senhaNova: "",
    confirmacaoSenha: ""
  };

  @observable
  avatar = "";

  @observable
  avatars = CsAvatar.values.map(avatar => ({
    value: avatar.codigo,
    label: avatar.nome,
    icone: avatar.icone
  }));

  @observable
  fetching = false;

  @action.bound
  async obterUsuarioLogado() {
    try {
      this.fetching = true;

      const result = await Usuario.obterLogado(sessaoStore.usuario.login);
      if (result && result.erro) {
        return error(result.erro);
      }

      this.usuario = result;
      this.avatar = {
        value: result.avatar,
        label: CsAvatar.valueOf(result.avatar).nome,
        icone: CsAvatar.valueOf(result.avatar).icone
      };
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async atualizarPerfil() {
    try {
      this.fetching = true;

      const erros = this.validarPerfilUsuario(this.usuario);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Usuario.atualizarPerfil(this.usuario);

      if (result.erro) {
        return error(result.erro);
      }

      success("Perfil atualizado com sucesso.\n\rPara visualizar as alterações efetue o login novamente.");
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  handleChange = ({ target }) => {
    const { name, value } = target;

    this.usuario[name] = value;
  };

  @action.bound
  definirAvatar = target => {
    this.usuario.avatar = target.value;
    this.avatar = target;
  };

  validarPerfilUsuario = registro => {
    const erros = validarCamposObrigatorios()
      .addSeNuloOuVazio("Nome", registro.nome)
      .addSeNuloOuVazio("Email", registro.email)
      .addSeNuloOuVazio("Login", registro.login)
      .addSeNuloOuVazio("Avatar", registro.avatar)
      .build();

    return erros;
  };
}

export default new PerfilStore();



// WEBPACK FOOTER //
// ./src/views/seguranca/stores/PerfilStore.js